export const changePriority = (xs: { id: any; }[],
                               id: any,
                               to: number,
                               idx = xs.findIndex(({id: i}) => i == id),
                               ys = [...xs.slice(0, idx), ...xs.slice(idx + 1)]
) =>
    [...ys.slice(0, to - 1), xs [idx], ...ys.slice(to - 1)]
        .map((x, i) => ({...x, listOrder: i + 1}))
